import type { EnumUnion } from '@dresscode-frontend/utility-types';

/**
 * 親タブのキー。MegaMenu の最上位タブを表す。
 *
 * - `IN_USE` / `IN_INVENTORY` は複数の CategoryKey を内包する 2 段構成タブ
 * - その他は単一 CategoryKey に 1:1 で対応する
 */
export const TabKey = {
  IN_USE: 'IN_USE',
  IN_INVENTORY: 'IN_INVENTORY',
  UNDER_REPAIR: 'UNDER_REPAIR',
  IN_DISTRIBUTION: 'IN_DISTRIBUTION',
  ALL: 'ALL',
  DECOMMISSIONED: 'DECOMMISSIONED'
} as const;
export type TabKey = EnumUnion<typeof TabKey>;

/**
 * デバイス一覧 v4 のカテゴリキー。
 * URL クエリの `category` と API リクエストの category 値に対応する。
 */
export const CategoryKey = {
  IN_USED: 'IN_USED',
  IN_PLACED: 'IN_PLACED',
  IN_STOCK: 'IN_STOCK',
  FAULTY: 'IN_TROUBLED',
  REFURBISHING: 'REFURBISHING',
  UNDER_REPAIR: 'UNDER_REPAIR',
  IN_DISTRIBUTION: 'IN_DISTRIBUTION',
  ALL: 'ALL',
  DECOMMISSIONED: 'DECOMMISSIONED'
} as const;
export type CategoryKey = EnumUnion<typeof CategoryKey>;

/**
 * MegaMenu 内の表示専用キー（URL / API の category には使わない）。
 * `findSelected` が実カテゴリと衝突しないように親行・All 行に用いる。
 */
export const DeviceInventoryMegaMenuPanelKey = {
  IN_USE_SUMMARY: 'IN_USE_SUMMARY',
  IN_USE_ALL_ROW: 'IN_USE_ALL_ROW',
  IN_INVENTORY_SUMMARY: 'IN_INVENTORY_SUMMARY',
  IN_INVENTORY_ALL_ROW: 'IN_INVENTORY_ALL_ROW'
} as const;
export type DeviceInventoryMegaMenuPanelKey = EnumUnion<typeof DeviceInventoryMegaMenuPanelKey>;

/** URL / API に載せる CategoryKey のみ true */
export function isDeviceInventoryCategoryKey(value: string): value is CategoryKey {
  return (Object.values(CategoryKey) as string[]).includes(value);
}
export type DeviceInventoryMegaMenuValue = CategoryKey | DeviceInventoryMegaMenuPanelKey;